module.exports = __webpack_public_path__ + "img/1999_L.48937467.png";